<template>
  <div class="prod">
    <div class="prod_a">
      <div class="img"><img :src="detailData.product_file_url" alt=""></div>
      <div class="desc">
        <div>{{ detailData.product_name }}</div>
        <div>$ {{ detailData.amount }}</div>
      </div>
    </div>
    <div class="prod_b">
      <div>
        <i></i>
        <span>Currency</span>
      </div>
    </div>
    <div class="prod_b prod_c">
      <div>
        <i></i>
        <span>Applicable Platform: {{ detailData.platform }}</span>
      </div>
    </div>
    <div style="width: 100%">
    <div class="prod_d">
      {{ detailData.product_content }}
      <!-- <div>[Item Content]: 150+15 Diamonds*1 </div>
      <div>[Usage Description]:</div>
      <div class="weight">[Discount Event: the first recharge immediately grants double diamonds, once only]</div>
      <div class="margin">
        <p>1.The First Purchase Double will only be triggered onc
        e. When it is already triggered in the game, you cannot
        trigger First Purchase double anymore by
        purchasing from this page.</p>
        <p>2. Using the diamonds recharged from this item to take part in the in-game total recharge event.</p>
      </div>
      <div class="margin">
        <p>[Remark]:</p>
        <p>After completing the purchase, the purchased item will be sent to your account in around 10s.Please</p>
      </div> -->
    </div>
  </div>
    <div class="prod_b">
      <div></div>
      <div></div>
    </div>
    <div class="prod_e">
      <div class="cont">
        <div>Total: ${{ detailData.amount }}</div>
        <div @click="nextStep">Pay Now</div>
      </div>
    </div>

    <cust></cust>
  </div>
</template>

<script>
import { getPayPrice, banners } from '@/api/api';
import cust from '../../components/customer.vue'
import { axiosServer } from '@/api/http';
import { getSign } from "@/api/utils";
export default{
  data() {
    return {
      detailData: {},
      app_key: '1df869f2e620513484ddbd5521313a60'
    }
  },
  components: {
    cust
  },
  created() {
    this.detailData = this.$route.query || {};
    console.log(this.detailData)
  },
  methods: {
    nextStep() {
      this.reportEvent(4)
      this.$router.push({path: '/submit', query: this.detailData});
    },
    reportEvent(event) {
      let params = {
        game_id: localStorage.getItem('game_id'),
        area: localStorage.getItem('area'),
        product_id: this.detailData.id,
        product_type: this.detailData.type,
        report_type: event,
      }
      axiosServer({
        url: "report",
        type: "post",
        params: {
          ...params,
          sign: getSign(this.app_key, params),
        },
      }).then((res) => {
        console.log(res)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.prod {
  background: #f1f1f1;

  .prod_a {
    display: flex;
    padding: .25rem .28rem;

    .img {
      position: relative;

      img {
        width: 1.59rem;
      }
    }

    .desc {
      margin-left: 0.2rem;

      div:nth-child(1) {
        color: #010101;
        font-size: 0.28rem;
      }

      div:nth-child(2) {
        color: #ff0600;
        font-size: 0.34rem;
        margin-top: 0.1rem;
      }
    }
  }
  .prod_b{
    // width: 100%;
    background: #fff;
    padding: 0.13rem 0.28rem;
    div {line-height: 0.5rem;}
    div i{
      width: 0.12rem;
      height: .50rem;
      background: #4378ff;
      display: inline-block;
      vertical-align: top;
    }
    div span{
      margin-left: 0.13rem;
      font-size: .28rem;
      color: #010101;
    }
  }
  .prod_c{margin-top: 0.2rem;}
  .prod_d{
    margin-top: 0.2rem;
    background: #fff;
    padding: 0.18rem 0.28rem;
    color: #010101;
    font-size: .28rem;
    .weight{
      font-weight: bold;
    }
    .margin{
      margin-top: .38rem;
    }
  }
  .prod_e{
    position: fixed;bottom: 0;
    left: 50%;
    max-width: 7.2rem;
    transform: translate(-50%, 0);
    height: .84rem;
    width: 100%;
    background: #fff;
    .cont{
      padding: 0 0.28rem;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      div:nth-child(1) {
        font-size: 0.28rem;
        color: #010101;
      }
      div:nth-child(2) {
        width: 1.75rem;
        height: .54rem;
        background: #fc4335;
        line-height: .54rem;
        font-size: .28rem;
        color: #fff;
        text-align: center;
        border-radius: 0.2rem;
        cursor: pointer;
      } 
    }
  }
}
</style>